<template>
    <div>
        <b-modal id="modal-prevent-closing" class="header-modal" no-close-on-backdrop hide-footer ref="modal-delete-user-class-school">
            <div class="modal-delete-class_school__body">
                <h4>
                        <strong>Xóa học sinh</strong>
                    </h4>
                <div class="font-size-20 text-center primary-color-txt font-sanpro-light">
                    Bạn có chắc chắn muốn xóa <strong>"{{ item.name }}"</strong> không?  <br />
                </div>
                <div class="modal__actions text-right">
                    <a href="javascript:;" class="primary-color-txt font-size-17 btn-cancel" @click="handleHideModal">Hủy</a>
                    <a href="javascript:;" class="font-size-17 font-sanpro-semibold btn-delete" @click="handleDelete()">Đồng ý</a>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
import {DeleteMemberInClassSchoolService} from './../_api/classSchoolUserServices'
export default {
    name: "ModalDeleteUserClassSchool",
    props: {
        item: {
            type: Object,
            // eslint-disable-next-line vue/require-valid-default-prop
            default: {}
        }
    },
    data() {
        return {
            confirmActive: {},
            isLoading: false,
        }
    },
    mounted(){
        this.handleShowModal()
    },
    computed: {
        screenWidth() {
            return window.innerWidth;
        },
        
    },
    methods: {
        
        handleDelete() {
            let self = this
            DeleteMemberInClassSchoolService(this.item.id).then(res=>{
                if (res && res.data && !res.errors) {
                    self.$toast.success('Xóa thành viên thành công')
                    this.handleHideModal()
                    self.$emit('handleDeleteDone')
                    
                }
            })
        },
        handleHideModal() {
            this.$emit('closeModal')
        },
        handleShowModal() {
            this.$refs['modal-delete-user-class-school'].show()
        }
    }
}
</script>
<style lang="scss" scoped>
.modal-delete-class_school__body{
    padding: 20px;
    background-color: white;
    .modal__actions{
        margin-top: 10px;
        .btn-delete{
            color: white;
            background: #fe0201;
            padding: 5px 20px 5px 20px;
            border-radius: 15px;
            
        }
        .btn-cancel{
            margin-right: 10px;
        }
    }
}
.modal-content {
    background-color: red;
}

.wrap-form-save-class-school {
    padding-top: 20px;
    background-color: white;
}

.form_action {
    margin-top: 10px;
    padding-bottom: 10px;
}

.justity-content-space-between {
    justify-content: center
}
.modal__actions{
    margin-bottom: 20px;
    .btn-leaver{
        background: #ff0101;
        color: white;
        border-radius: 15px;
    }
}
</style>